let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6p7Vp")).then(() => parcelRequire('bPPZx'));